import { BaseRequest } from 'src/app/tools/models/dtos/base-request';
import { AssetProductCategory } from 'src/app/assabil-kernel/models/entities/control-tables/asset-product-category-entity';
import { UserInfo } from 'src/app/tools/models/entities/user-info';


export class AssetProductCategoryRequest extends BaseRequest{
  assetProductCategory : AssetProductCategory;
  constructor(userInfo : UserInfo){    
    super(userInfo);
    this.assetProductCategory = new AssetProductCategory();
  }
}